import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';

import { LoadStatus, Random } from "../utils";

import './RetryableContent.scss';

class RetryableContent extends Component {

    idComponent = Random.randomComponentId();

    componentDidUpdate(prevProps) {
        const { status, isPlaceOrder } = this.props;
        const { status: prevStatus } = prevProps;
        if (isPlaceOrder === true && status !== prevStatus && status === LoadStatus.LOADING) {
            this.blockAllInput();
        }

        if (isPlaceOrder === true && status !== prevStatus && prevStatus === LoadStatus.LOADING) {
            this.unBlockInput();
        }
    }


    unBlockInput = () => {
        document.querySelectorAll(`#${this.idComponent} input, #${this.idComponent} button`).forEach(function (element) {
            // Khôi phục giá trị tabindex ban đầu
            let originalTabindex = element.getAttribute('data-tabindex');
            if (originalTabindex !== null) {
                element.setAttribute('tabindex', originalTabindex);
            }

            // Khôi phục trạng thái disabled ban đầu
            let originalDisabled = element.getAttribute('data-disabled') === 'true';
            element.disabled = originalDisabled;
        });
    }

    blockAllInput = () => {
        document.querySelectorAll(`#${this.idComponent} input, #${this.idComponent} button`).forEach(function (element) {
            // Lưu trạng thái ban đầu
            element.setAttribute('data-tabindex', element.getAttribute('tabindex'));
            element.setAttribute('data-disabled', element.disabled);

            // Chặn tương tác bằng cách đặt tabindex = -1 và thêm disabled
            element.setAttribute('tabindex', '-1');
            element.setAttribute('disabled', 'disabled');
        });
    }

    render() {
        const { className, children, onRetry, status, disableRetry, isPlaceOrder, customRetry, ...otherProps } = this.props;
        const classes = className ? [className] : [];
        classes.push('retryable-content');

        if (status === LoadStatus.LOADING) {
            isPlaceOrder === true ? classes.push('loading-order') : classes.push('loading');
        } else if (status === LoadStatus.FAIL) {
            classes.push('fail');
        }

        if (disableRetry) {
            classes.push('disable-retry');
        }

        return (
            <div id={this.idComponent} className={classes.join(' ')} {...otherProps}>
                {status === LoadStatus.LOADING && isPlaceOrder === true && (<div className='prevent-action-block'></div>)}
                {React.Children.map(children, child => {
                    return React.cloneElement(child, {
                        className: child.props.className ? child.props.className + ' retryable-content-body' : 'retryable-content-body'
                    })
                })}
                {!disableRetry && !customRetry && (
                    <div className="retryable-content-retry">
                        <div className="wrapper">
                            <div className="message">
                                <FormattedMessage id="common.fail-to-load-data" />
                            </div>
                            <div className="action">
                                <button className="btn btn-info link" onClick={onRetry}>
                                    <FormattedMessage id="common.retry" />
                                </button>
                            </div>
                        </div>
                    </div>
                )}
                {!disableRetry && customRetry && (
                    <div className="retryable-content-retry">
                        <div className="wrapper">
                            {customRetry()}
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default RetryableContent;